module.exports = __webpack_public_path__ + "static/img/beans-off.53ef7ab7.png";